export default __webpack_public_path__ + "static/media/09.cfc1feef.jpg";